import { HttpStatusCode, isAxiosError } from 'axios'

const MESSAGE_PAR_DEFAUT = 'Une erreur est survenue.'

/**
 * Message à afficher dans un bandeau : celui de l'API (`APIError.message`) s'il existe, sinon une traduction
 * de la panne. Jamais le message brut d'axios (« Network Error », « Request failed with status code … »)
 * ni celui d'une erreur interne du front.
 */
export function messageErreur(e: unknown): string {
  if (!isAxiosError<{ message?: string }>(e)) return MESSAGE_PAR_DEFAUT
  if (e.response?.data?.message) return e.response.data.message
  // Pas de réponse lisible : réseau coupé, serveur arrêté, ou refus du proxy sans en-têtes CORS
  if (!e.response) return 'Serveur injoignable, vérifiez votre connexion.'
  const statut = e.response.status
  if (statut === HttpStatusCode.Unauthorized) return 'Session expirée, rechargez la page.'
  // 413 de Traefik (limite de taille des téléversements) : pas de corps JSON
  if (statut === HttpStatusCode.PayloadTooLarge) return 'Fichier trop volumineux.'
  if (statut >= HttpStatusCode.InternalServerError) return 'Erreur du serveur, réessayez plus tard.'
  return MESSAGE_PAR_DEFAUT
}
